var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header-wrapper',[_c('a-card',{attrs:{"bordered":false}},[_c('a-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.loginKf(_vm.record, undefined)}}},[_c('a-icon',{attrs:{"type":"plus1"}}),_vm._v(_vm._s(_vm.$t('通用.按钮.平台客服'))+" ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }